const isEqual = require("lodash.isequal");

export const dataActionsTypes = {
  MERGE_DATA_STATUS: "MERGE_DATA_STATUS",
  SET_DATA_STATUS: "SET_DATA_STATUS"
};

export const setDataStatus = (key, value) => ({
  type: dataActionsTypes.SET_DATA_STATUS,
  key,
  value
});

export const mergeDataStatus = (value) => ({
  type: dataActionsTypes.MERGE_DATA_STATUS,
  value
});

export const dataReducer = (state, action) => {
  //console.log("🪬 DataReducer", state, action);
  switch (action.type) {
    case dataActionsTypes.MERGE_DATA_STATUS: {
      const newState = { ...state, ...action.value };
      if (isEqual(newState, state)) return state;
      return newState;
    }
    case dataActionsTypes.SET_DATA_STATUS: {
      if (isEqual(state[action.key], action.value)) return state;
      return { ...state, [action.key]: action.value };
    }
    default: {
      return state;
    }
  }
};
